<template>
    <div>
        <!-- Button trigger modal -->
        <button id="login_btn" class="btn btn-primary" data-bs-toggle="modal" data-bs-target="#login"
            style="display:none;">
        </button>
        <button id="register_btn" class="btn btn-primary" data-bs-toggle="modal" href="#registerModalToggle"
            style="display:none;"></button>
        <login v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        <changePassword v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        <historialIngresos v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        <register ref="register" v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
        <nav v-if="user.token !== ''" class="navbarCustom navbar-dark py-0" id="mainHeader">
            <myAccountJM v-bind:skin="skin" v-bind:language="language" v-bind:translation="translation" />
            <div class="d-flex p-2 py-2" style="width:100%;max-height: 50px;" :style="skin.header_mobil.nav_bar">
                <span style="width: 10%;" class="position-relative me-2 my-1" data-bs-toggle="offcanvas"
                    data-bs-target="#offcanvasExample" aria-controls="offcanvasExample">
                    <span style="font-size: large;"><i class="fas fa-bars"></i></span>
                </span>

                <div style="width: 90%;" class="d-flex" :style="skin.header_desktop.nav_bar_text">

                    <div v-if="user.token != ''" class="px-2 pe-2 text-center" style="display:table;width: 88%;" :style="skin.header_desktop.selection">

                        <div v-if="skin.customActionButton.enabled" @click="user.token != '' ? action() : login()"
                            class="btn-support" href="#" aria-expanded="false"
                            sstyle="cursor:pointer;width:5%;display:table-cell;vertical-align:middle;font-size: 15px;">
                            <i class="fa fa-external-link fa-fw"></i>
                        </div>
                        <div v-if="skin.header_mobil.balance"
                            style="cursor:pointer;width:40%;display:table-cell;vertical-align:middle;font-size: 15px;"
                            class="text-end">
                            <i @click="showBalanceAction" class="fas fa-coins pr-0"></i>
                            <span class="mx-2" v-if="showBalance">{{ user.user_data.data ? new
                                Intl.NumberFormat("de-DE", {
                                    minimumFractionDigits:
                                        skin.qBet_config.decimalsQty, maximumFractionDigits:
                                        skin.qBet_config.decimalsQty
                                }).format(balance.saldo) : 0 }}</span>
                        </div>
                        <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_mobil.support" class="text-end"
                            style="cursor:pointer;width:20%;display:table-cell;vertical-align:middle;">
                            <span :style="(this.message_recived ? 'color:red;' : '')" @click="openSupportModalJivo()">
                                <i class="fa-regular fa-comment-dots"></i>
                            </span>
                            <div class="dropdown-menu p-2" aria-labelledby="navbarDropdown3"
                                style="width: 19rem!important;color: #fff!important;background-color: rgba(60,60,60,.9);font-size: 15px;">
                                <div class="text-center">
                                    <span>• {{ translate('mesa') }} •</span>
                                </div>
                                <div class="my-1 mb-1" data-bs-toggle="modal" data-bs-target="#supportJm"
                                    @click="openSupportModal('newMessage')">
                                    <i class="fa-solid fa-paper-plane mx-2"></i>
                                    <span style="">{{ translate('reportar') }}</span>
                                </div>
                                <div class="my-1 mb-1">
                                    <a class="dropdown-item support-item support-item-read"
                                        v-for="(ticket, index) in supportTickets" :key="index" href="#" data-id="402987"
                                        style="color: rgb(197, 194, 194)!important;background-color: rgba(60,60,60,.9);font-size: 15px;"
                                        data-bs-toggle="modal" data-bs-target="#supportJm"
                                        @click="openSupportModal(ticket)">
                                        <!-- <span :style="ticket.leido_user_creacion==1?'color:red;':''"><i class="far fa-comment me-2" aria-hidden="true"></i></span> -->
                                        <span>Ticket #{{ ticket.id }}</span>
                                        <span class="float-end"> {{ countDays(ticket.fecha) }}d <i class="far fa-clock"
                                                aria-hidden="true"></i></span>
                                    </a>
                                </div>
                                <div class="text-center">
                                    <span>• {{ translate('notifi') }} •</span>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div v-if="user.token == '' && skin.register" @click="register"
                        style="cursor:pointer;display:table;width: 100%;" :style="skin.header_desktop.register_btn"
                        class="py-2 px-2 pe-2 text-center">
                        <span style="display:table-cell;vertical-align:middle;">{{ translate("sign_in") }}</span>
                    </div>
                    <div v-if="user.token != ''" style="display:table;cursor:pointer;width:18%"
                        class="py-0 my-0 pb-1 text-center nav-item dropdown dropstart">
                        <a :style="skin.header_desktop.nav_bar_text" style="display:table-cell;vertical-align:middle;"
                            class="nav-link py-1" href="#" id="navbarDropdown" role="button" data-bs-toggle="dropdown"
                            aria-expanded="false">
                            <i class="far fa-user"></i>
                        </a>
                        <div style="color: #fff!important;background-color: rgba(60,60,60,.9);font-size: 15px;"
                            class="dropdown-menu" aria-labelledby="navbarDropdown">
                            <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_mobil.userMenu.changePassword"
                                class="px-2 pe-2" data-bs-toggle="modal" data-bs-target="#changePasswordJm">
                                <span>{{ translate('change_password') }}</span>
                            </div>
                            <div v-if="skin.my_account.myaccount_type == 'JM'">
                                <div v-if="skin.header_mobil.userMenu.balanceHistory" @click="getMovements()"
                                    class="px-2 pe-2 p-1" data-bs-toggle="modal" data-bs-target="#myAccountJm">
                                    <span>{{ translate('balance_history') }}</span>
                                </div>
                            </div>
                            <div v-else class="px-2 pe-2 p-1" data-bs-toggle="modal" data-bs-target="#myAccount">
                                <span>{{ translate('balance_history') }}</span>
                            </div>
                            <div v-if="skin.my_account.myaccount_type == 'JM' && skin.header_mobil.userMenu.loginHistory"
                                @click="getIngresos()" class="px-2 pe-2 p-1" data-bs-toggle="modal"
                                data-bs-target="#historial_ingresos"> <span>{{ translate('history_ingre') }}</span> </div>
                            <div v-if="skin.header_mobil.userMenu.sportsRules" @click="terms" class="px-2 pe-2 p-1">
                                <span>{{ translate('regulations') }}</span>
                            </div>
                            <!-- <a @click="change_view('results')" class="px-2 pe-2 p-1" :style="skin.header_desktop.servicios_text2"> <span>{{translate("results")}}</span> </a> -->
                            <div v-if="skin.logout" @click="logout" class="px-2 pe-2 p-1"> <span>{{ translate('close') }}</span>
                            </div>
                        </div>
                    </div>
                    <div class="align-self-center">
                        <languageSelector :skin="skin" :language="language">
                        </languageSelector>
                    </div>
                </div>
            </div>
        </nav>
        <nav v-else class="navbarCustom navbar-dark py-0" id="mainHeader">
            <div class="d-flex p-3 py-2" :style="skin.header_mobil.nav_bar" style="width: 100%;min-height: 50px;">

                <span class="align-self-center" data-bs-toggle="offcanvas" data-bs-target="#offcanvasExample"
                    aria-controls="offcanvasExample">
                    <span style="color:#ccc;font-size: large;"><i class="fas fa-bars"></i></span>
                </span>
                <!-- <div><img class="mx-2" :src="skin.header_mobil.logo" :width="skin.header_mobil.logo_width" alt=""></div> -->
                <div class="text-end" style="width: 50%;">
                    <button v-if="user.token == '' && skin.register" style="font-size: small;"
                        class="p-1 px-2 pe-2 me-1 text-center btn" @click="register"
                        :style="skin.header_mobil.register_btn">{{ translate("sign_in") }}</button>
                </div>
                <div style="cursor:pointer;display:table;width: 50%;font-size: small;"
                    :style="skin.header_desktop.login_btn" class="py-2 px-2 pe-2 text-end">
                    <span v-if="user.token == ''" @click="login" style="display:table-cell;vertical-align:middle;"><i
                            class="fas fa-sign-in-alt"></i> {{ translate("log_in") }}</span>
                </div>
                <div class="align-self-center">
                    <languageSelector :skin="skin" :language="language">
                    </languageSelector>
                </div>
            </div>
        </nav>
    </div>
</template>

<script>
import myAccountJM from "./my_account.vue";
import languageSelector from './language.vue';
import login from "./login.vue";
import register from './register.vue';
import changePassword from "./changePassword.vue";
import historialIngresos from "./historialIngresos.vue";

export default {
    name: "header_mobil",
    props: ["skin", "translation", "language"],
    components: { languageSelector, myAccountJM, login, register, changePassword, historialIngresos },
    data() {
        return {
            userDataLoaded: false,
            showBalance: false,
            supportTickets: [],
            balance: {
                saldo: 0,
                conversion: 0,
                view: "SALDO",
                switch: 1
            },
        }
    },
    computed: {
        jivo_modal_flag() {
            return this.$store.getters["getModalFlag"]
        },
        message_recived() {
            return this.$store.getters["getMessage"]
        },
        jivoElement1() {
            return this.$store.getters['jivoElement1'];
        },
        user() {
            let data = this.$store.getters['getUserData'];
            if (data.user_data.data) {
                this.balance.saldo = data.user_data.data.balance;
                this.balance.conversion = data.user_data.data.balance * data.user_data.data.tasa;
                this.userDataLoaded = true;
            }
            return data;
        },
        currency() {
            return this.$store.getters['getCurrency'];
        },
    },
    methods: {
        action() {
            let customButton = this.$props.skin.customActionButton;
            if (customButton.action == 'redirection') {
                let url = customButton.actionData.url;
                let parameters = customButton.actionData.parameters;
                parameters.forEach(param => {
                    url += (url.includes('?') ? '&' : '?') + `${param}=${encodeURIComponent(this.user.user_data.data[param])}`;
                });
                console.log(url, this.user.user_data.data, this.$props.skin.customActionButton);
                window.open(url, '_blank');
            }
        },
        openSupportModalJivo() {
            const jivoMobileElement = this.jivoElement1;
            if (this.jivo_modal_flag) {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'none'; // Ocultar el elemento móvil
                }
                this.$store.dispatch("setJivo_modal_flag", false);
            } else {
                if (jivoMobileElement) {
                    jivoMobileElement.style.display = 'block'; // Mostrar el elemento móvil
                    jivo_api.open()
                }
                this.$store.dispatch("setJivo_modal_flag", true);
                this.$store.dispatch("setMessage", false);
            }
        },
        showBalanceAction() {
            if (!this.showBalance) {
                this.$store.dispatch('getProfile', {
                    token: this.user.token,
                    site_id: this.user.site_id,
                    site: this.user.site,
                    prefix: this.user.prefix,
                    playerId: this.user.user_data?.data?.user_id,
                    source: "main"
                });
                this.showBalance = true
            }
            else {
                this.showBalance = false
            }
        },
        countDays(init) {
            // Crear dos objetos Date con las fechas que quieres comparar
            var fecha1 = new Date(init);
            var fecha2 = new Date();

            // Calcular la diferencia en milisegundos entre las dos fechas
            var diferenciaEnMilisegundos = fecha2 - fecha1;

            // Convertir la diferencia en días
            var diferenciaEnDias = diferenciaEnMilisegundos / (1000 * 60 * 60 * 24);

            // Redondear la diferencia si es necesario
            diferenciaEnDias = Math.round(diferenciaEnDias);
            return diferenciaEnDias;
        },
        terms() {
            let url = "";
            let lang = this.$props.language == 'es' ? 'spa' : (this.$props.language == 'en' ? 'eng' : (this.$props.language == 'pt' ? 'pt-br' : 'spa'));
            if (this.user.prefix == "external") {
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + this.user.site.toUpperCase() + "&link=" + this.user.site;
            }
            else {
                let domain_formated = this.user.domain.split('//')[1];
                let domain_name1 = domain_formated.split('.')[1].toUpperCase();
                let domain_name2 = domain_formated.split('.')[1] + '.' + domain_formated.split('.')[2];
                url = "https://docs.betsw3.xyz/terms/" + lang + "/?site=" + domain_name1 + "&link=" + domain_name2;
            }

            window.open(url, '_blank').focus();
        },
        getMovements() {
            this.$root.$emit('getMovementsHistory');
        },
        getIngresos() {
            this.$root.$emit('getIngresosHistory');
        },
        show_user_recharge() {
            this.$root.$emit("show_user_recharge");
        },
        balanceParsed(val, fiat) {
            let tasa = 1;
            if (this.$props.skin.conversion ? (this.$props.skin.conversion.enabled ? true : false) : false) {
                tasa = this.currency.rate;
            }
            return (fiat != 'BETC' ? (fiat == 'USDT' ? val * tasa : val * tasa * this.user.user_data.data.tasa) : val).toFixed(2);
        },
        login() {
            document.getElementById('login_btn').click();
        },
        logout() {
            this.$store.dispatch('logOut');
            this.$root.$emit('forceRender');
        },
        register() {
            document.getElementById('register_btn').click();
        },
        change_view(view) {
            this.$store.dispatch('setView', view);
        },
        translate(text) {
            if (text) {
                if (this.$props.translation[text]) {
                    return this.$props.translation[text][this.$props.language];
                }
                else {
                    var new_text_serched = text.replace(/ /g, "_");
                    if (this.$props.translation[new_text_serched]) {
                        return this.$props.translation[new_text_serched][this.$props.language];
                    }
                }
                return text;
            }
        }
    },
    watch: {
        showBalance(newVal, oldVal) {
            if (newVal) {
                let self = this
                setTimeout(() => {
                    self.showBalance = false
                }, 5000);
            }
        }
    },
    mounted() {
        this.$store.dispatch("setHeaderHeight", document.getElementById("mainHeader").offsetHeight + 5);
        this.$root.$on('openLogin', () => {
            this.login();
        });
    },
    beforeDestroy() {
        this.$root.$off('openLogin');
    }
}
</script>

<style>
.navbarCustom {
    border: none;
    background-color: #1c1c1c;
    /* Color de fondo por defecto */
    /* position: fixed; */
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    width: 100%;
}
</style>